/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepo.defs'
export { main as default } from './getRepo.defs'
